// extracted by mini-css-extract-plugin
export default {"siteloader":"siteloader_siteloader__1Xg9B","main":"siteloader_main__VTHxe","center":"siteloader_center__OYTgw","middle":"siteloader_middle__ch0wL","top":"siteloader_top__KS0PN"};